// Shared min-width floor + centered content so every Severity / Status badge
// renders a consistent pill (labels vary: "High" vs "Critical", "Open" vs
// "In progress"). `max-content` keeps the pill hugging its label so it never
// stretches across the cell; the floor lines short labels up down the column.
.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  min-width: 80px;
  max-width: 100%;
}

// Status pills share a larger floor sized to the widest label ("In progress")
// so every status (Open / In progress / Resolved / Closed / Cancelled) renders
// the exact same width — a uniform column. Defined after `.badge` so this
// min-width wins. Severity badges keep the smaller `.badge` floor.
.status-badge {
  min-width: 104px;
}

// Source badge — deliberately the quietest thing in the row. It answers "where
// did this row come from", which matters only when it is NOT the normal answer,
// so it is muted grey (the `inactive` Badge variant) and set in small caps with
// tracking: readable as a label at a glance, without competing with the
// Severity and Status pills the page is actually scanned for.
.source-badge {
  min-width: 0;
  padding-inline: 8px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
